const initialState = {
  permissionFlags: null,
  extensions: [],
  pluginField: '',
  installedPlugins: [],
  pluginDetail: null,
  roles: [],
  xanoSwaggerApis: [],
  loadAllExtensionPending: false,
  loadAllExtensionError: null,
  loadPluginFieldsPending: false,
  loadPluginFieldsError: null,
  installPluginPending: false,
  installPluginError: null,
  loadAllInstalledPluginPending: false,
  loadAllInstalledPluginError: null,
  loadInstalledPluginDetailPending: false,
  loadInstalledPluginDetailError: null,
  updateInstalledPluginPending: false,
  updateInstalledPluginError: null,
  deleteInstalledPluginPending: false,
  deleteInstalledPluginError: null,
  loadRolesPending: false,
  loadRolesError: null,
  loadProjectDetailPending: false,
  loadProjectDetailError: null,
  deletePermissionPending: false,
  deletePermissionError: null,
};

export default initialState;
